// src/services/menuService.js

import menus from "../components/ui/Header/menus";

 const apiUrl = process.env.REACT_APP_API_URL;

export async function rideMenus() {
    try {
        const res = await fetch(`${apiUrl}attractionsMenu`);
        const data = await res.json();
        if (!data) {
            console.warn("Menu API returned invalid response", data);
            return menus;
        }

        
        const dynamicChildren = data.map(item => ({
            name: item.name,
            link: item.link,
            menu_id: item.menu_id
        }));
        const updated = menus.map(menu => {
            if (menu.id === 3) {
                return {
                    ...menu,
                    children: dynamicChildren
                };
            }
            return menu;
        });
        return updated;

    } catch (err) {
        console.error("Failed to load menus:", err);
        return menus; // fallback to static menus
    }
}
